module.exports = __webpack_public_path__ + "img/1 (13).2a299205.png";